"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var FinanceRevsharesList_1 = require("./component/FinanceRevsharesList");
var FinanceRevshareEditor_1 = require("./component/FinanceRevshareEditor");
var PFinanceRevsharesList = /** @class */ (function (_super) {
    __extends(PFinanceRevsharesList, _super);
    function PFinanceRevsharesList(props) {
        return _super.call(this, props) || this;
    }
    PFinanceRevsharesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AP = this.props.pprogramsList.Subscribe("*", function (id, data) {
            _this.setState({ avail_pprograms: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                pprograms_list: data.pprograms_list,
                all_pprograms: data.all_pprograms,
                page_size: data.tablePageSize
            });
        });
        this.SID_ARFT = this.props.revshareFlowTypesAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_revshare_flow_types: data.data });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            pprograms_list: this.props.state.getPProgramsList(),
            all_pprograms: this.props.state.getIsAllPPrograms(),
            avail_pprograms: [],
            avail_revshare_flow_types: []
        }, function () {
            _this.props.pprogramsList.LoadData();
            _this.props.revshareFlowTypesAvail.LoadData();
        });
    };
    PFinanceRevsharesList.prototype.componentWillUnmount = function () {
        this.props.pprogramsList.UnSubscribe(this.SID_AP);
        this.props.state.UnSubscribe(this.SID_STATE);
        this.props.revshareFlowTypesAvail.UnSubscribe(this.SID_ARFT);
    };
    PFinanceRevsharesList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PFinanceRevsharesList.prototype.onBrandFilterChanged = function (allPPrograms, PProgramId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllPPrograms(allPPrograms, true);
        }
        if (Action === "add") {
            this.props.state.addPProgram(PProgramId, true);
        }
        if (Action === "remove") {
            this.props.state.delPProgram(PProgramId, true);
        }
    };
    PFinanceRevsharesList.prototype.backToListClick = function () {
        this.setState({ edit_mode: "LIST" });
    };
    PFinanceRevsharesList.prototype.newRevshareClick = function () {
        this.setState({ edit_mode: "NEW" });
    };
    PFinanceRevsharesList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(FinanceRevsharesList_1.default, { data: this.props.data, state: this.props.state, onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, PProgramsList: this.state.pprograms_list, allPPrograms: this.state.all_pprograms, availPPrograms: this.state.avail_pprograms, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), onNewrevShare: this.newRevshareClick.bind(this), dlgCalculateRevShare: this.props.dlgCalculateRevShare }));
        }
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(FinanceRevshareEditor_1.default, { data: this.props.data, state: this.props.state, onGoBack: this.backToListClick.bind(this), pprogramsList: this.props.pprogramsList, pprogramPartnersList: this.props.pprogramPartnersList, pprogramPartnersOffersList: this.props.pprogramPartnersOffersList, availRevshareFlowTypes: this.state.avail_revshare_flow_types }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PFinanceRevsharesList.prototype.render = function () {
        return this.getRenderObject();
    };
    PFinanceRevsharesList.getPageDescription = function (state) {
        return {
            icon: "hand-holding-usd",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_finance_revshares_list + "-id",
            itemTitle: "Ревшара",
            route: routes_1.routes.page_finance_revshares_list,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PFinanceRevsharesList;
}(React.Component));
exports.default = PFinanceRevsharesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_revshares_list/ui/PFinanceRevsharesList.tsx
// module id = 2453
// module chunks = 0